import { render } from "./Help.vue?vue&type=template&id=366d6baa&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=366d6baa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366d6baa"]])

export default __exports__